import React from 'react';
import { Checkbox, Col, DatePicker, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Insegna')} name='company_title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Modello annuncio')} name='vacancy_category'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item label={t('Settore')} name='vacancy_application_type'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Valido fino a')} name='expired_at'>
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Descrizione')} name='description'>
          <Input.TextArea placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={18}>
        <Form.Item name='hide_brand'>
          <Checkbox>Nascondi insegna?</Checkbox>
        </Form.Item>
      </Col>
      <Col span={6}>
        <Typography.Title level={3}>
          {t('INFORMAZIONI AGGIUNTIVE')}
        </Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Tipo del campo')} name='field_type'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
